import React from 'react'
import { MaxValueLabel, SliderC, SliderWrapper } from '~/pages/Farmer/Survey/RequestEntries/AnswerForms/Slider'
import styled from 'styled-components'
import { SliderContainer } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'

interface Props {
  name: string
  label: string
}

const SliderLabel = styled.div`
text-align: left;
font-weight: 700;
color: rgb(94, 102, 114);
margin-bottom: 7px;
`

const FeedSlider: React.FC<Props> = ({ name, label }) => {
  const { control, setValue } = useFormContext()
  const value = useWatch({ control, name })

  return <SliderContainer style={{ marginBottom: 10, minWidth: 300 }}>
    <SliderLabel>{label}</SliderLabel>
    <SliderWrapper>
      <SliderC
        step={5}
        rating={parseInt(value) || 0}
        min={0}
        max={100}
        value={value || 0}
        onChange={(e) => setValue(name, e.target.value)}
      />
      <MaxValueLabel style={{ fontWeight: 'normal' }}>{`${parseInt(value) || 0}%`}</MaxValueLabel>
    </SliderWrapper>
  </SliderContainer>
}
export default FeedSlider